import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/action', label: '热血少年' },
  { path: '/category/romance', label: '浪漫爱情' },
  { path: '/category/thriller', label: '悬疑惊悚' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 group"
            aria-label="073漫画网首页"
          >
            <span className="text-2xl font-bold font-heading text-primary-500">
              073
            </span>
            <span className="text-sm font-label text-foreground-700 hidden sm:block">
              漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-label transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? 'bg-primary-500/15 text-primary-500'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-500 hover:text-foreground-900 hover:bg-background-100 transition-all cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <button
              className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-500 hover:text-foreground-900 hover:bg-background-100 transition-all cursor-pointer"
              aria-label="书架"
            >
              <i className="ri-bookmark-line text-lg"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-all cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 py-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-label transition-all cursor-pointer ${
                  isActive(link.path)
                    ? 'bg-primary-500/15 text-primary-500'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}